import { Component } from '@angular/core';
import { ButtonsProviderService } from '../../services/buttons-provider/buttons-provider.service';
import { CallcardDetailButtonsComponent } from '../callcard-detail-buttons/callcard-detail-buttons.component';

@Component({
  selector: 'app-callcard-detail-buttons-v',
  templateUrl: './callcard-detail-buttons-v.component.html',
  styleUrls: ['./callcard-detail-buttons-v.component.scss']
})
export class CallcardDetailButtonsVComponent extends CallcardDetailButtonsComponent {
  constructor(protected buttonsProvider: ButtonsProviderService) {
    super(buttonsProvider);
  }
}
